export enum StorageKeys {
    AuthenticationService = "authentication",
    Version = "version",
    TaskJobDraftPrefix = "taskjobdraft-",
    GeneralSettings = "generalsettings-"
}
